import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
// Compact card for dense data layouts
const CompactCard = React.forwardRef(({ className, children, padding = 'md', ...props }, ref) => {
    const paddingClasses = {
        sm: 'p-3',
        md: 'p-4',
        lg: 'p-6'
    };
    return (_jsx("div", { ref: ref, className: cn('bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-sm', paddingClasses[padding], className), ...props, children: children }));
});
CompactCard.displayName = 'CompactCard';
const CompactCardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('mb-3 pb-2 border-b border-gray-200 dark:border-gray-700', className), ...props })));
CompactCardHeader.displayName = 'CompactCardHeader';
const CompactCardTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h4", { ref: ref, className: cn('text-sm font-medium text-gray-900 dark:text-gray-100', className), ...props })));
CompactCardTitle.displayName = 'CompactCardTitle';
const CompactCardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('text-sm', className), ...props })));
CompactCardContent.displayName = 'CompactCardContent';
export { CompactCard, CompactCardHeader, CompactCardTitle, CompactCardContent };
